<template>
  <content-container :overlay="false" :container="false">
    <b-container fluid class="mb-3">
      <div>
        <b-form-input
          :placeholder="$t('search.clients')"
          class="mb-5"
          v-model="query"
          debounce="300"
          type="search"
          autofocus
        ></b-form-input>
      </div>
      <!-- User Interface controls -->
      <b-row align-h="between">
        <b-col sm="4" class="my-1"> </b-col>
        <b-col sm="8" md="6" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-0"
            @change="update()"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-container>

    <b-table
      id="users"
      class="prevent-selection clickable-rows"
      :busy.sync="isBusy"
      :items="usersProvider"
      :fields="fields"
      @row-clicked="rowClicked"
      show-empty
      hover
      stacked="md"
      ref="userList"
    >
      <template v-slot:table-busy>
        <div class="slot-filler text-center text-secondary center-both">
          <b-spinner class="align-middle mr-3"></b-spinner>
          <strong>{{ $t("data.loading") }}</strong>
        </div>
      </template>
      <template v-slot:empty="scope">
        <div class="slot-filler align-middle text-center center-both">
          <h4>{{ scope.emptyText }}</h4>
        </div>
      </template>
      <template v-slot:emptyfiltered="scope">
        <h4>{{ scope.emptyFilteredText }}</h4>
      </template>

      <template v-slot:head(company)="">
        <span>{{ $t("table.company") }}</span>
      </template>
      <template v-slot:head(user)="">
        <span>{{ $t("table.user") }}</span>
      </template>
      <template v-slot:head(roles)="">
        <span>{{ $t("table.roles") }}</span>
      </template>
      <template v-slot:head(lang)="">
        <span>{{ $t("table.lang") }}</span>
      </template>

      <template v-slot:cell(company)="data">
        <template v-if="data.item.is_individual"> </template>
        <template v-else>
          <span
            class="company"
            v-if="data.item"
            v-html="boldString(data.item.company, query)"
          ></span>
          <span
            class="dba"
            v-if="data.item.dba"
            v-html="boldString(data.item.dba, query)"
          ></span>
          <span class="item-id text-secondary">
            {{ data.item.id }}
          </span>
        </template>
      </template>

      <template v-slot:cell(user)="data">
        <span
          class="company"
          v-if="data.item.user"
          v-html="
            boldString(
              data.item.user.first_name + ' ' + data.item.user.last_name,
              query
            )
          "
        ></span>
        <span
          class="email"
          v-if="data.item.user.email"
          v-html="boldString(data.item.user.email.email, query)"
        ></span>
      </template>

      <template v-slot:cell(roles)="data">
        <b v-if="data.item.user.roles.includes('root')">root</b>
        <span v-else>{{
          data.item.user.roles
            .map(function (i) {
              return i.charAt(0).toUpperCase() + i.slice(1);
            })
            .join(", ")
        }}</span>
      </template>
      <template v-slot:cell(lang)="data">
        <span>{{ localeName(data.item.user.settings.locale) }}</span>
      </template>
    </b-table>
  </content-container>
</template>

<script>
import { getLocaleName } from "@/util/supported-locales";
import ContentContainer from '../ContentContainer.vue';
import { URL_SEARCH_CLIENT } from "@/globals"

export default {
  components: { ContentContainer },
  name: "UserList",
  data() {
    return {
      query: "",
      isBusy: false,
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      pageOptions: [5, 10, 15],
      fields: [
        {
          key: "company",
        },
        {
          key: "user",
        },
        {
          key: "roles",
        },
        {
          key: "lang",
        },
      ],
    };
  },
  watch: {
    query: function () {
      this.update();
    },
  },
  methods: {
    update() {
      this.$refs.userList.refresh();
    },
    usersProvider() {
      // Here we don't set isBusy prop, so busy state will be
      // handled by table itself
      // this.isBusy = true

      let promise = this.$post(
        URL_SEARCH_CLIENT,
        JSON.stringify({
          page: this.currentPage,
          page_size: this.perPage,
          query: this.query,
        })
      );
      return promise
        .then((result) => {
          this.currentPage = result.result_info.page;
          this.totalRows = result.result_info.total_count;
          const items = result.items;
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          return items;
        })
        .catch(() => {
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          return [];
        });
    },
    localeName(code) {
      return getLocaleName(code);
    },
    boldString(str, substr) {
      if (substr && substr.length >= 1) {
        return str.replace(
          new RegExp("(^)(" + substr + ")(.*$)", "gmi"),
          "$1<b>$2</b>$3"
        );
      } else {
        return str;
      }
    },
    rowClicked(item) {
      this.$router.push({
        name: "clientDetails",
        params: { id: item.id, item: item },
      });
      //console.log("Item: ", item);
    },
  },
};
</script>

<style scoped>
@import "../../common.scss";

.company {
  display: block;
}
.dba {
  font-size: 90%;
  opacity: 0.9;
  display: block;
}
.email {
  font-size: 90%;
  opacity: 0.9;
}
.slot-filler {
  min-height: 200px;
}
</style>